document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-ess-brand-tabs]').forEach(function (wrapper) {
    var tabs = wrapper.querySelectorAll('[data-ess-tab]');
    var panels = wrapper.querySelectorAll('[data-ess-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-ess-tab');

        tabs.forEach(function (item) {
          item.classList.remove('is-active');
        });

        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
        });

        tab.classList.add('is-active');

        var activePanel = wrapper.querySelector('[data-ess-panel="' + target + '"]');
        if (activePanel) {
          activePanel.classList.add('is-active');
        }
      });
    });
  });

  document.querySelectorAll('.ess-brand-product-card').forEach(function (card) {
    var variantButtons = card.querySelectorAll('.ess-brand-product-card__variant');
    var price = card.querySelector('.ess-brand-product-card__price');
    var cta = card.querySelector('.ess-brand-product-card__button');

    variantButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        variantButtons.forEach(function (item) {
          item.classList.remove('is-active');
        });

        button.classList.add('is-active');

        if (price && button.dataset.variantPrice) {
          price.classList.add('is-changing');

          window.setTimeout(function () {
            price.textContent = button.dataset.variantPrice;
            price.classList.remove('is-changing');
          }, 160);
        }

        if (cta && button.dataset.variantUrl) {
          cta.setAttribute('href', button.dataset.variantUrl);
        }
      });
    });
  });

  var revealItems = document.querySelectorAll(
    '.ess-brand-page--header .ess-brand-page__header, .ess-brand-page--story .ess-brand-page__history, .ess-brand-page--origin .ess-brand-page__origin, .ess-brand-page--collections .ess-brand-page__collections'
  );

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ess-is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.14
    });

    revealItems.forEach(function (item) {
      item.classList.add('ess-motion-reveal');
      observer.observe(item);
    });
  } else {
    revealItems.forEach(function (item) {
      item.classList.add('ess-is-visible');
    });
  }
});